var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/lib/Accordion.tsx
import MuiAccordion from "@mui/material/Accordion";
import { styled } from "@mui/material/styles";
import { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
var FilledAccordion = styled(MuiAccordion, {
  name: "MuiAccordion",
  slot: "AvFilled",
  overridesResolver: (props, styles) => styles.avFilled
})(({ theme }) => ({
  borderColor: theme.palette.grey[100],
  "> .MuiAccordion-heading .MuiAccordionSummary-root": {
    backgroundColor: theme.palette.grey[100]
  }
}));
var OutlinedAccordion = styled(MuiAccordion, {
  name: "MuiAccordion",
  slot: "AvOutlined",
  overridesResolver: (props, styles) => styles.avOutlined
})(({ theme }) => ({
  borderColor: theme.palette.divider,
  "> .MuiAccordion-heading .MuiAccordionSummary-root:not(.Mui-focusVisible, :hover, :active)": {
    backgroundColor: theme.palette.background.paper
  },
  "> .MuiCollapse-root > .MuiCollapse-wrapper > .MuiCollapse-wrapperInner > .MuiAccordion-region > .MuiAccordionDetails-root:first-of-type": {
    borderTop: `1px solid ${theme.palette.divider}`
  }
}));
var Accordion = forwardRef((allProps, ref) => {
  const _a = allProps, { variant = "filled", disableNestedStyling = false, className } = _a, props = __objRest(_a, ["variant", "disableNestedStyling", "className"]);
  const classnames = `${variant === "filled" ? "MuiAccordion-avFilled" : "MuiAccordion-avOutlined"}${disableNestedStyling ? " Av-disableNested" : ""} ${className || ""}`;
  return variant === "filled" ? /* @__PURE__ */ jsx(FilledAccordion, __spreadProps(__spreadValues({ className: classnames }, props), { ref })) : /* @__PURE__ */ jsx(OutlinedAccordion, __spreadProps(__spreadValues({ className: classnames }, props), { ref }));
});

// src/lib/AccordionActions.tsx
import MuiAccordionActions from "@mui/material/AccordionActions";
import { forwardRef as forwardRef2 } from "react";
import { jsx as jsx2 } from "react/jsx-runtime";
var AccordionActions = forwardRef2((props, ref) => /* @__PURE__ */ jsx2(MuiAccordionActions, __spreadProps(__spreadValues({}, props), { ref })));

// src/lib/AccordionDetails.tsx
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import { forwardRef as forwardRef3 } from "react";
import { jsx as jsx3 } from "react/jsx-runtime";
var AccordionDetails = forwardRef3((props, ref) => /* @__PURE__ */ jsx3(MuiAccordionDetails, __spreadProps(__spreadValues({}, props), { ref })));

// src/lib/AccordionSummary.tsx
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import { TriangleExpandIcon } from "@availity/mui-icon";

// ../typography/src/lib/Typography.tsx
import { forwardRef as forwardRef4 } from "react";
import { default as MuiTypography } from "@mui/material/Typography";
import { jsx as jsx4 } from "react/jsx-runtime";
var Typography = forwardRef4(
  (_a, ref) => {
    var _b = _a, { children } = _b, rest = __objRest(_b, ["children"]);
    return /* @__PURE__ */ jsx4(MuiTypography, __spreadProps(__spreadValues({}, rest), { ref, children }));
  }
);

// src/lib/AccordionSummary.tsx
import { forwardRef as forwardRef5 } from "react";
import { styled as styled2 } from "@mui/material/styles";
import { jsx as jsx5, jsxs } from "react/jsx-runtime";
var PrimaryContent = styled2(Typography, {
  name: "MuiAccordionSummary",
  slot: "AvPrimaryContent",
  overridesResolver: (props, styles) => styles.avPrimaryContent
})(({ theme }) => ({
  marginRight: "auto",
  paddingRight: theme.spacing(1),
  lineHeight: "1.5rem"
}));
var SecondaryContent = styled2(Typography, {
  name: "MuiAccordionSummary",
  slot: "AvSecondaryContent",
  overridesResolver: (props, styles) => styles.avSecondaryContent
})({});
var AccordionSummary = forwardRef5((allProps, ref) => {
  const _a = allProps, { children, primary: primaryProp, primaryProps, secondary: secondaryProp, secondaryProps } = _a, props = __objRest(_a, ["children", "primary", "primaryProps", "secondary", "secondaryProps"]);
  const combinedPrimaryProps = __spreadValues({
    className: "MuiAccordionSummary-avPrimaryContent",
    variant: "h6",
    component: "div"
  }, primaryProps);
  const combinedSecondaryProps = __spreadValues({
    className: "MuiAccordionSummary-avSecondaryContent",
    variant: "body1",
    component: "div"
  }, secondaryProps);
  const Primary = /* @__PURE__ */ jsx5(PrimaryContent, __spreadProps(__spreadValues({}, combinedPrimaryProps), { children: primaryProp || children }));
  const Secondary = secondaryProp ? /* @__PURE__ */ jsx5(SecondaryContent, __spreadProps(__spreadValues({}, combinedSecondaryProps), { children: secondaryProp })) : null;
  return /* @__PURE__ */ jsxs(MuiAccordionSummary, __spreadProps(__spreadValues({}, props), { expandIcon: /* @__PURE__ */ jsx5(TriangleExpandIcon, {}), ref, children: [
    Primary,
    Secondary
  ] }));
});
export {
  Accordion,
  AccordionActions,
  AccordionDetails,
  AccordionSummary
};
